/**
 * Client-side countdown. Runs entirely in the browser because Liquid output
 * is cached by Shopify, so a server-rendered countdown would freeze.
 *
 * Markup contract, on any element with [data-countdown]:
 *   data-countdown-target      ISO datetime string (drop target)
 *   [data-countdown-active]    wrapper shown while counting down
 *   [data-countdown-days]      text node updated with remaining days
 *   [data-countdown-hours]     text node updated with remaining hours
 *   [data-countdown-minutes]   text node updated with remaining minutes
 *   [data-countdown-seconds]   text node updated with remaining seconds
 *   [data-countdown-complete]  element shown once the target has passed
 */
(function () {
  function pad(value) {
    return String(Math.max(value, 0)).padStart(2, '0');
  }

  function run(root) {
    var targetTime = new Date(root.getAttribute('data-countdown-target')).getTime();

    if (isNaN(targetTime)) {
      return;
    }

    var active = root.querySelector('[data-countdown-active]');
    var complete = root.querySelector('[data-countdown-complete]');
    var daysEl = root.querySelector('[data-countdown-days]');
    var hoursEl = root.querySelector('[data-countdown-hours]');
    var minutesEl = root.querySelector('[data-countdown-minutes]');
    var secondsEl = root.querySelector('[data-countdown-seconds]');
    var timerId;

    function render() {
      var diff = targetTime - Date.now();

      if (diff <= 0) {
        window.clearTimeout(timerId);
        if (active) active.hidden = true;
        if (complete) complete.hidden = false;
        return;
      }

      var days = Math.floor(diff / 86400000);
      var hours = Math.floor((diff % 86400000) / 3600000);
      var minutes = Math.floor((diff % 3600000) / 60000);
      var seconds = Math.floor((diff % 60000) / 1000);

      if (daysEl) daysEl.textContent = pad(days);
      if (hoursEl) hoursEl.textContent = pad(hours);
      if (minutesEl) minutesEl.textContent = pad(minutes);
      if (secondsEl) secondsEl.textContent = pad(seconds);

      timerId = window.setTimeout(render, 1000);
    }

    render();
  }

  function init() {
    document.querySelectorAll('[data-countdown]').forEach(run);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
